import { render, staticRenderFns } from "./addressInfo.vue?vue&type=template&id=08529594&scoped=true"
import script from "./addressInfo.vue?vue&type=script&lang=js"
export * from "./addressInfo.vue?vue&type=script&lang=js"
import style0 from "./addressInfo.vue?vue&type=style&index=0&id=08529594&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08529594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08529594')) {
      api.createRecord('08529594', component.options)
    } else {
      api.reload('08529594', component.options)
    }
    module.hot.accept("./addressInfo.vue?vue&type=template&id=08529594&scoped=true", function () {
      api.rerender('08529594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/userManagement/components/addressInfo.vue"
export default component.exports